<template>
  <div id="VUE_APP">
    <transition name="fade" tag="div" >
      <HotelsInfoWithFiltering v-if="showHotels" ref="hiwf" :duration="1000" :rawData="rawData" :showHotels="showHotels" :offerPage="offerPage" />
      <div class="wrapper e-skeleton hotels-info-with-filtering" v-else>
        <div class="bg"></div>
      </div>
    </transition>
  </div>
</template>

<script>
import HotelsInfoWithFiltering from './containers/HotelsInfoWithFiltering.vue';
import { DestinationsService } from './services/http/DestinationsService.js';
export default {
  data() {
    return {
      rawData: {},
      errors: [],
      showHotels: false,
      offerPage: false
    }
  },
  mounted() {
    this.offerPage = this.$parent.$refs.hotelsInfoWithFilteringContainer.getAttribute('data-offer-id') ? true : false
    /**
        * Request the api call for Hotels and Filters
        * @return: Object
      */
    DestinationsService.requestHotelsAndFilters(this.$parent.$refs.hotelsInfoWithFilteringContainer.getAttribute('data-rose-gold'), this.$parent.$refs.hotelsInfoWithFilteringContainer.getAttribute('data-offer-id'))
      .then(res => {
        const response = res.data;
        this.rawData = response
        this.showHotels = true
      })
      .catch(e => {
        this.errors.push(JSON.parse(e))
      })
  },
  components: {
    HotelsInfoWithFiltering
  }
}
</script>
